<template>
    <a-card>
        <keep-alive>
            <component v-if="ifShow" :formData="getFullData"  :is="currentComponent"></component>
        </keep-alive>
    </a-card>
</template>

<script>
// import { message } from 'ant-design-vue';

// import { reactive } from 'vue'
import { tableListMixin } from "@/mixins";
import { enterpriseOperatingIncome } from "@/api/integral";
import seed from "./components/seed" //种子期
import newly from "./components/newly" //初创期
import maturation from "./components/maturation" //成长期
import growth from "./components/growth" //成熟期

export default {
    name:"index",
    mixins: [tableListMixin],
    components:{
        seed,
        newly,
        maturation,
        growth
    },
    data(){
        return{
            ifShow:false,
            getDetailNoteParam:null,//参数
            fillingTimeId:null,//填报时间ID
            operatingIncomeScale:null,//营业收入规模
            currentComponent:seed,
            visible:true,
            getFullData:null
        }
    },
    mounted() {

    },
    methods:{
        getAdd(){
            const data = JSON.parse(this.$route.query.getDetailNoteParam);
            this.postAction({
                url: enterpriseOperatingIncome.detailNote,
                params: {
                    ...data,
                    operatingIncomeScale: this.$route.query.id,
                    operatingIncomeFile: this.$route.query.operatingIncomeFile,
                    operatingIncomeFile1: this.$route.query.operatingIncomeFile1,
                    operatingIncomeFile2: this.$route.query.operatingIncomeFile2,
                    operatingIncomeFile3: this.$route.query.operatingIncomeFile3,
                },
                returnMsg: true,
            }).then((res) => {
                if(res.data.boolean == false){
                    this.$router.push({path: '/sys/manage'});
                }else{
                    this.getFullData = res.data
                    this.ifShow = true
                    switch(res.data.type){
                        case "A":
                            this.currentComponent=seed
                            break; //种子期
                        case "B":this.currentComponent=newly
                            break; //初创期
                        case "C":this.currentComponent=growth
                            break; //成长期
                        case "D":this.currentComponent=maturation
                            break; //成熟期
                    }
                }
            }).catch(() => {
                this.$router.push({path: '/sys/manage'});
            });
        },
        getEdit(){
            const data = JSON.parse(this.$route.query.getDetailNoteParam);
            this.getAction({
                    url: enterpriseOperatingIncome.getManageDetail,
                    params: {
                      ...data
                    },
                    returnMsg: true,
                }).then((res) => {
                    this.getFullData = res.data
                    this.ifShow = true
                    switch(res.data.type){
                        case "A":
                            this.currentComponent=seed
                            break; //种子期
                        case "B":this.currentComponent=newly
                            break; //初创期
                        case "C":this.currentComponent=growth
                            break; //成长期
                        case "D":this.currentComponent=maturation
                            break; //成熟期
                    }
                })
        },
        getDetailNote(id) {
            this.ifShow = false;
            if(id==0){
                this.getEdit()
            }else{
                this.getAdd()
            }

        },

    },
    created() {

        this.getDetailNote(this.$route.query.id)
    }
}


</script>

<style lang="less" scoped>
.integralItem-title{
    margin: 20px 0;
    p,em{
        color:red
    }
    p{
        font-size: 12px;
    }
}
.integralItem-cont{
    margin:20px;
    .ant-input-number,input{
        width:60%;
         margin-right:20px
    }
    .item-form{
        p{
            color:red;
            margin-top: 5px;
        }
    }
}
</style>
